import React, { useState, Suspense } from "react";
// import Home from "./Component/Home";
import About from "./Component/AboutUs";
import Contact from "./Component/ContactUs";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import LoginSignUp from "./Component/login-signup/LoginSignup";
import MBBS from "./Component/MBBS";
import MbbsIndia from "./Component/MbbsIndia";
import MbbsAbroad from "./Component/MbbsAbroad";
import Immigration from "./Component/Immigration";
import Test from "./Component/Test";
import TestPages from "./TestPages/TestPages";
import PrivacyPolicy from "./PrivacyPages/PrivacyPolicy";
import RefundPolicy from "./PrivacyPages/RefundPolicy";
import TermsAndConditions from "./PrivacyPages/TermsAndCondition";
import DashboardLayout from "./Dashboard/DashboardLayout";
import DashboardHome from "./Dashboard/DashboardHome";
import Community from "./Dashboard/Community/Community";
import JoinCommunity from "./Dashboard/Community/JoinCommunity";
import CreateCommunityPost from "./Dashboard/Community/Createpost";
import StudyAbroad from "./CountryPages/StudyAbroad";
import StudyAbroadMainPage from "./CountryPages/StudyAbroadMainPage";
import StudyAbroadCountryInfo from "./CountryPages/StudyAbroadCountryInfo";
import MbbsCountryMainpage from "./MBBSCountries/MbbsCountryMainPage";
import MbbsCountryMainPage from "./MBBSCountries/MbbsCountryMainPage";
import AddCart from "./Cart/AddCart";
import DashboardOrder from "./Dashboard/DashboardOrder";
import OrderStatus from "./Cart/SuccessPage";
import ThankYouPage from "./Component/thankYouPage";
import DashboardOrderDetail from "./Dashboard/DashboardOrderDetail";
import DashboardPreCounsellingForm from "./Dashboard/DashboardPreCounsellingForm";
import DashboardEnrollmentStepper from "./Dashboard/Enrollment/DashboardStepper";
import ForgetPassword from "./Component/login-signup/ForgetPassword";
import ResetPassword from "./Component/login-signup/ResetPassword";
import ImmigrationCountryPage from "./immigration/ImmigrationCountryPage";
import UniversityPage from "./CountryPages/UniversityPage";
import NotFound from "./Component/NotFound";
import SelectCourses from "./CountryPages/Courses/SelectCourses";
import CoursePage from "./CountryPages/CoursePage";

import Performances from "./Dashboard/Performance/Performances";
import Planner from "./Dashboard/Planner/Planner";
import ComingSoon from "./Component/ComingSoon";
import ScheduleForm from "./Dashboard/DashboardComponents/ScheduleForm";
import ProfileForm from "./Dashboard/DashboardComponents/ProfileForm";
import Notifications from "./Dashboard/DashboardComponents/Notification";
import TestPage from "./Dashboard/MockTest/Components/TestPage";
import SelectUniversities from "./CountryPages/University/SelectUniversities";
import EmptyScoreBoard from "./Dashboard/MockTest/Components/EmptyPage";
import AdmissionDashboard from "./Dashboard/StudyAbroadDashboard/AdmissionDashboard";
import ProgressCard from "./Dashboard/Study Abroad/components/ProgressCard";
import BlogDetails from "./Component/card-components/BlogDetails";
import Immersion from "./Component/Immersion";
import ImmersionCountryPage from "./Component/immersion/ImmersionCountryPage";
import { Provider } from "react-redux";
import { store } from "../src/redux/store";
import DelhiNCR from "./Component/DelhiNCR";
import Kolkata from "./Component/Kolkata";
import CustomViewPDFPage from "./Component/custom/CustomViewPDFPage";
import UniversityCompare from "./UniversityFinder/universityCompare";
import { usePreventScreenshotShortcuts } from "./custom-hooks/usePreventScreenshotShortcuts";
import InternationalRelationMainPage from "./Component/InternationalRelation/InternationalRelationMainPage";
import MainIndiaPage from "./Component/InternationalRelation/IndiaPage/MainIndiaPage";
import ManavRachnaUniversity from "./Component/InternationalRelation/IndiaPage/components/IndianUniversities/universities/ManavRachanaPage/ManavRachnaUniversity";
import GalgotiasUniversity from "./Component/InternationalRelation/IndiaPage/components/IndianUniversities/universities/GalgotiasPage/GalgotiasUniversity";
import GdGoenkaUniversity from "./Component/InternationalRelation/IndiaPage/components/IndianUniversities/universities/GdGoenkaPage/GdGoenkaUniversity";
import ImiKolkata from "./Component/InternationalRelation/IndiaPage/components/IndianUniversities/universities/ImiKolkataPage/Imikolkata";
import JISUniversity from "./Component/InternationalRelation/IndiaPage/components/IndianUniversities/universities/JISPage/JISUniversity";
import DashboardTestPrep from "./Dashboard/DashboardTestPrep";
import StudyAbroadPurchase from "./Dashboard/Study Abroad/components/StudyAbroadPurchase";
import DocumentVerification from "./Dashboard/Study Abroad/components/DocumentVerification";
import LearningResources from "./Dashboard/LearningResources/LearningResources";
import Mocktest from "./Dashboard/MockTest/MockTest";
import MockTestList from "./Dashboard/MockTest/Components/MockTestList";
import MockScoreBoardtest from "./Dashboard/MockTest/MockScoreBoard";
import Support from "./Dashboard/Support/support";
import UniversityFinder from "./UniversityFinder/UniversityFinder";
import UniversityView from "./UniversityFinder/UniversityView";
import UniversityDetailsForApplication from "./Dashboard/Study Abroad/MyProgress.js/ThirdPart/UniversityDetailsForApplication";
import { SnackbarProvider } from "./Component/Snakbar";
import Resources from "./Dashboard/Study Abroad/components/Resources";

const TestPrepHome = React.lazy(() =>
  import("./Dashboard/TestPrepHome/TestPrepHome")
);

const App = () => {
  const [itemupdate, setItemUpdate] = useState(false);
  usePreventScreenshotShortcuts();

  return (
    <Router>
      <Provider store={store}>
        <SnackbarProvider>
          <Suspense fallback={<div>Loading...</div>}>
            <Routes>
              {/* <Route path="/" element={<Home />} /> */}
              <Route path="/login" element={<LoginSignUp />} />
              <Route path="signup" element={<LoginSignUp />} />
              <Route path="forgetpassword" element={<ForgetPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="aboutus" element={<About />} />
              <Route path="contact" element={<Contact />} />
              {/* <Route path="services" element={<Services />} /> */}
              <Route path="mbbs" element={<MBBS />} />
              <Route path="blogdetails/:slugUrl" element={<BlogDetails />} />
              <Route path="immigration" element={<Immigration />} />

              <Route path="immersion" element={<Immersion />} />
              <Route
                path="immersion/:pageName"
                element={<ImmersionCountryPage />}
              />

              <Route
                path="immigration/:pageName"
                element={<ImmigrationCountryPage />}
              />
              <Route path="mbbs/india" element={<MbbsIndia />} />
              <Route path="mbbs/abroad" element={<MbbsAbroad />} />
              <Route
                path="mbbs/abroad/:pageName"
                element={<MbbsCountryMainPage />}
              />
              <Route path="test" element={<Test />} />

              <Route
                path="test/:pageName"
                element={
                  <TestPages
                    setItemUpdate={setItemUpdate}
                    itemupdate={itemupdate}
                  />
                }
              />
              <Route path="privacy-policy" element={<PrivacyPolicy />} />
              <Route path="refund-policy" element={<RefundPolicy />} />
              <Route
                path="terms-&-conditions"
                element={<TermsAndConditions />}
              />

              <Route path="dashboard" element={<DashboardLayout />}>
                <Route path="home" index element={<DashboardHome />} />
                <Route path="test-prep" index element={<DashboardTestPrep />} />
                <Route
                  path="/dashboard/studyabroad-purchase"
                  index
                  element={<StudyAbroadPurchase />}
                />
                <Route path="notifications" index element={<Notifications />} />
                <Route path="profileupdate" index element={<ProfileForm />} />
                <Route path="scheduleForm" index element={<ScheduleForm />} />
                <Route path="community" index element={<Community />} />
                <Route
                  path="documentsverification"
                  index
                  element={<DocumentVerification />}
                />
                <Route path="resources" index element={<Resources />} />
                <Route
                  path="community/joincommunity"
                  index
                  element={<JoinCommunity />}
                  // element={<JoinTheTaksheelaCommunity />}
                />
                <Route
                  path="community/joincommunity/createcommunitypost"
                  index
                  element={<CreateCommunityPost />}
                />
                <Route
                  path="community/CreateCommunity"
                  index
                  element={<CreateCommunityPost />}
                />
                <Route path="user-board" index element={<TestPrepHome />} />
                <Route path="order" element={<DashboardOrder />} />
                <Route
                  path="learningresources"
                  element={<LearningResources />}
                />
                <Route path="mocktest" element={<Mocktest />} />
                {/* <Route path="practiceassignment" element={<PracticeAssignment />} /> */}
                <Route path="studyabroad" element={<ProgressCard />} />
                <Route
                  path="study-abroad/university/:id"
                  element={<UniversityDetailsForApplication />}
                />
                <Route
                  path="mocktest/mocktestList/:id/:type"
                  element={<MockTestList />}
                />
                {/* <Route
              path="practiceassignment/:id"
              element={<PracticeAssignmentTestList />}
            /> */}

                <Route
                  path="mocktest/testPage/:testTypeParams/:id/:type"
                  element={<TestPage />}
                />

                <Route
                  path="mocktest/mocktestList/mockscoreboard"
                  element={<MockScoreBoardtest />}
                />
                <Route
                  path=":id/:type/scoretable"
                  element={<MockScoreBoardtest />}
                />
                <Route path="scorepending" element={<EmptyScoreBoard />} />
                <Route path="admission" element={<AdmissionDashboard />} />
                <Route path="support" element={<Support />} />
                <Route path="performance" element={<Performances />} />
                <Route path="planner" element={<Planner />} />
                <Route
                  path="/dashboard/:parentpage/view-resource-file"
                  element={<CustomViewPDFPage />}
                />

                <Route
                  path="order/order-details/:id"
                  element={<DashboardOrderDetail />}
                />
                <Route
                  path="enrollment/enrollment-form"
                  element={<DashboardEnrollmentStepper />}
                />

                <Route
                  path="precounselling-form"
                  element={<DashboardPreCounsellingForm />}
                />
              </Route>
              <Route path="study-abroad" element={<StudyAbroadMainPage />} />
              <Route path="study-abroad/country" element={<StudyAbroad />} />

              <Route
                path="study-abroad/country/:pageName"
                element={<StudyAbroadCountryInfo />}
              />
              <Route
                path="study-abroad/universities"
                element={<SelectUniversities />}
                // element={<UniversityFinder />}
              />
              <Route
                path="study-abroad/universityFinder"
                // element={<SelectUniversities />}
                element={<UniversityFinder />}
              />
              <Route
                path="study-abroad/universities/view/Compare"
                element={<UniversityCompare />}
              />
              <Route
                path="study-abroad/universities/view"
                element={<UniversityView />}
              />
              <Route
                path="study-abroad/universities/:pageName"
                element={<UniversityPage />}
              />

              <Route path="study-abroad/courses" element={<SelectCourses />} />
              <Route
                path="study-abroad/courses/:pageName"
                element={<CoursePage />}
              />
              <Route path="mbbs/Countries" element={<MbbsCountryMainpage />} />
              <Route
                path="addCart"
                element={
                  <AddCart
                    setItemUpdate={setItemUpdate}
                    itemupdate={itemupdate}
                  />
                }
              />

              {/* ---------------------------- International Relation Page --------------------------- */}

              <Route
                path="international-relation"
                element={<InternationalRelationMainPage />}
              />
              <Route
                path="international-relation/india"
                element={<MainIndiaPage />}
              />

              <Route
                path="international-relation/india/manav-rachna-university"
                element={<ManavRachnaUniversity />}
              />

              <Route
                path="international-relation/india/galgotias-univeristy"
                element={<GalgotiasUniversity />}
              />

              <Route
                path="international-relation/india/gd-goenka-univeristy"
                element={<GdGoenkaUniversity />}
              />

              <Route
                path="international-relation/india/imi-kolkata"
                element={<ImiKolkata />}
              />

              <Route
                path="international-relation/india/jis-univeristy"
                element={<JISUniversity />}
              />
              {/* ------------------------------------------------------------------------------- */}

              <Route path="order-success" element={<OrderStatus />} />
              <Route path="thank-you" element={<ThankYouPage />} />
              <Route path="coming-soon" element={<ComingSoon />} />
              <Route path="*" element={<NotFound />} />
              <Route
                path="study-abroad-consultants-delhi-ncr"
                element={<DelhiNCR />}
              />
              <Route
                path="consultants-study-abroad-kolkata"
                element={<Kolkata />}
              />
            </Routes>
          </Suspense>
        </SnackbarProvider>
      </Provider>
    </Router>
  );
};

export default App;
